import { render, staticRenderFns } from "./footerMenu.vue?vue&type=template&id=7b1f97d5&scoped=true"
import script from "./footerMenu.vue?vue&type=script&lang=js"
export * from "./footerMenu.vue?vue&type=script&lang=js"
import style0 from "./footerMenu.vue?vue&type=style&index=0&id=7b1f97d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1f97d5",
  null
  
)

export default component.exports